<template>
  <div
    :class="[
      'bg-white rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-200',
      paddingClasses[padding]
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  padding?: 'sm' | 'md' | 'lg' | 'none'
}

withDefaults(defineProps<Props>(), {
  padding: 'md'
})

const paddingClasses = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8'
}
</script>